import { debounce } from '@/scripts/helpers/utils.js'

class Header extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.search()
        this.countrySelector()
        this.toggleExpanded()

        this.addEventListener(
            'mouseover',
            debounce(function (e) {
                var targetName = e.target.id
                var indexValue = e.target.getAttribute('meganav_heading_index')

                ;[...document.querySelectorAll('.mega-nav__item')].forEach((element) =>
                    element.classList.remove('active')
                )

                if (
                    (targetName && targetName.includes('meganav')) ||
                    indexValue !== null
                ) {
                    document
                        .getElementById('desktop-menu-overlay')
                        .classList.remove('hidden')
                } else if (e.target.getAttribute('data-item-index')) {
                    document
                        .getElementById('desktop-menu-overlay')
                        .classList.add('hidden')
                }

                if (
                    e.target.closest('.mega-nav__dropdown') !== null &&
                    e.target.closest('.mega-nav__dropdown').style.display === 'block'
                ) {
                    const parentItemIndex = e.target
                        .closest('.mega-nav__dropdown')
                        .getAttribute('meganav_index')
                    const parentItem = document.querySelector(
                        `[meganav_heading_index="${parentItemIndex}"]`
                    )
                    parentItem.classList.add('active')
                    console.log('parnt item', parentItem)
                }
            }, 200)
        )

        this.addEventListener(
            'mouseleave',
            debounce(this.mouseLeaveEvent.bind(this), 300)
        )
    }

    mouseLeaveEvent() {
        ;[...document.querySelectorAll('.mega-nav__item')].forEach((element) =>
            element.classList.remove('active')
        )
        this.querySelectorAll('[meganav_index]').forEach((element) => {
            document.getElementById('desktop-menu-overlay').classList.add('hidden')
        })
    }

    toggleExpanded() {
        const elements = document.querySelectorAll('[data-item-index]');
        elements.forEach(element => {
            element.addEventListener('focusin', () => {
                var indexValue = element.getAttribute('data-item-index');
                if (element.getAttribute('data-item-index') == indexValue) {
                    element.setAttribute('aria-expanded', 'true');
                    element?.closest?.('div')?.querySelector('.mega-nav__dropdown')?.classList.add('active');
                }
            });
           
            element.addEventListener('mouseover', () => {
                element.setAttribute('aria-expanded', 'true');
                element?.closest?.('div')?.querySelector('.mega-nav__dropdown')?.classList.add('active');
            });
            element.addEventListener('mouseout', () => {
                const expanded = element.getAttribute('aria-expanded');
                if (expanded !== null) {
                    element.setAttribute('aria-expanded', 'false');
                    element?.closest?.('div')?.querySelector('.mega-nav__dropdown')?.classList.remove('active');
                }
            });
        });
    }

    search() { 
        let searchTrigger = document.querySelectorAll('.trigger-search'),
            searchWrapper = this.querySelector('.search-wrapper'),
            searchInput = this.querySelector('.search-input'),
            searchResults = this.querySelector('.search-results')

        let lastSearchTrigger = null

        const positionSearchWrapper = () => {
            if (searchWrapper.classList.contains('!hidden')) return
            searchWrapper.style.height = `${window.innerHeight - searchWrapper.getBoundingClientRect().top}px`
        }

        window.addEventListener('resize', positionSearchWrapper)

        const setTriggersExpanded = (expanded) => {
            searchTrigger.forEach((trigger) => trigger.setAttribute('aria-expanded', expanded))
        }

        const closeSearch = () => {
            setTriggersExpanded(false)
            searchWrapper?.classList.add('!hidden')
            searchResults?.classList.add('!hidden')
            searchInput.value = ''
            window.algoliaShopify?.autocompleteInstances?.forEach((instance) => {
                instance.setQuery('')
                instance.setIsOpen(false)
            })
            lastSearchTrigger?.focus()
        }

        const getFocusableElements = () =>
            [
                lastSearchTrigger?.classList.contains('mobile-trigger-search') ? lastSearchTrigger : null,
                ...searchWrapper.querySelectorAll(
                    'a[href], button:enabled, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])'
                ),
            ].filter((el) => el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden')

        const trapTab = (e) => {
            const focusable = getFocusableElements()
            if (!focusable.length) return

            const first = focusable[0]
            const last = focusable[focusable.length - 1]

            if (!focusable.includes(document.activeElement)) {
                e.preventDefault()
                ;(e.shiftKey ? last : first).focus()
            } else if (e.shiftKey && document.activeElement === first) {
                e.preventDefault()
                last.focus()
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault()
                first.focus()
            }
        }

        document.addEventListener('keydown', function (e) {
            if (!searchWrapper || searchWrapper.classList.contains('!hidden')) return

            if (e.key === 'Escape') {
                const panelOpen = searchWrapper.querySelector('.aa-Panel')
                if (!(panelOpen && e.target.classList.contains('aa-Input'))) closeSearch()
                return
            }

            if (e.key === 'Tab') trapTab(e)
        })

        searchTrigger.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault()
                if (!searchWrapper.classList.contains('!hidden')) {
                    closeSearch()
                    return
                }
                lastSearchTrigger = trigger
                setTriggersExpanded(true)
                searchWrapper.classList.remove('!hidden')
                positionSearchWrapper()
                ;(document.getElementById('autocomplete-0-input') || searchInput).focus()
            })
        })

        searchInput.addEventListener('keyup', function (e) {
            e.target.value.length
                ? searchResults?.classList.remove('!hidden')
                : searchResults?.classList.add('!hidden')
        })

        // close search
        document.addEventListener('click', function (e) {
            if (
                e.target.closest('.close-search') ||
                e.target.classList.contains('search-wrapper')
            ) {
                closeSearch()
            }
        })
    }


    countrySelector() {
        setTimeout(() => {
            if(document.getElementById('md-footer-selector__form__id')) {
                document.querySelector('.custom-orbe').addEventListener('click', function() {
                    document.getElementById('md-form__select__country--footer').click()
                })

                document.querySelector(".custom-orbe-wrap").addEventListener('click', function() {
                    if(document.getElementById('md-form__select__country--footer').getAttribute('aria-expanded') === 'true') {
                        document.querySelector('.custom-orbe-arrow').classList.add('active')
                    } else {
                        document.querySelector('.custom-orbe-arrow').classList.remove('active')
                    }
                })

                if(window.innerWidth < 1110) {
                    const selector = document.querySelector(".custom-orbe-wrap");
                    const mobileMenu = document.querySelector(".mobile-menu_header-wrap");

                    if(selector) {
                        // mobileMenu.prepend(selector);
                        //selector.classList.remove('hidden')
                    }
                }

                //document.querySelector('.custom-orbe-wrap').classList.remove('hidden')
            }
        }, 100);
    }
}

customElements.define('main-header', Header)
